<template>
  <el-dialog v-model="show" top="50px" width="800px" @closed="close">
    <div class="avatar-upload-wrap">
      <vue-cropper
        v-if="imgSrc"
        ref="cropper"
        :aspect-ratio="aspectRatio"
        :src="`${imgSrc}`"
        preview=".preview"
      />
      <div class="avatar-upload-hint">
        {{ $t('common.ruleImage') }}
      </div>
      <div class="avatar-upload-footer">
        <el-upload
          action=""
          accept="image/*"
          :show-file-list="false"
          :on-change="onFileChange"
          :auto-upload="false"
        >
          <el-button type="primary">{{ $t('common.selectFile') }}</el-button>
        </el-upload>
        <el-button v-if="imgTemporaryUpload" @click="save" plain :disabled="!imgSrc">{{
          $t('common.save')
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

const FILE_SIZE_LIMIT = 15728640; // 15Mb

export default {
  emits: ['closed', 'saved'],
  props: {
    url: { type: String, required: true },
    aspectRatio: { type: Number, default: 1 },
    field: { type: String, default: 'file' }
  },
  components: {
    VueCropper
  },
  data() {
    return {
      show: true,
      imgSrc: null,
      cropImg: null,
      mimeType: '',
      fileName: '',
      imgTemporaryUpload: false
    };
  },
  methods: {
    save() {
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      this.$refs.cropper.getCroppedCanvas().toBlob(blob => {
        const formData = new FormData();
        formData.append(this.field, blob, this.fileName);
        this.$http({
          method: 'POST',
          url: this.url,
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' }
        })
          .then(() => {
            this.$emit('saved');
          })
          .catch(err => {
            console.error(err);
            let response = err.response.data;
            let message =
              response !== undefined && response !== null
                ? response
                : this.$t('common.savingOccurred');
            this.$message.error(message);
          });
      }, this.mimeType);
    },
    onFileChange(fileWrap) {
      this.imgTemporaryUpload = true;
      if (fileWrap.size > FILE_SIZE_LIMIT) {
        this.$message.error(this.$t('common.ruleFile'));
        return;
      }

      const file = fileWrap.raw;
      this.mimeType = file.type;
      this.fileName = file.name;

      if (file.type.indexOf('image/') === -1) {
        this.$message.error(this.$t('common.selectImage'));
        return;
      }

      const reader = new FileReader();
      reader.onload = event => {
        this.imgSrc = event.target.result;
        // rebuild cropperjs with the updated source
        if (this.$refs.cropper) {
          this.$refs.cropper.replace(event.target.result);
        }
      };
      reader.readAsDataURL(file);
      
    },
    close() {
      this.$emit('closed');
    }
  }
};
</script>

<style>
.avatar-upload-wrap .avatar-upload-hint {
  padding: 15px 0;
  text-align: center;
  color: black;
  font-size: 1.2em;
}
.avatar-upload-wrap .avatar-upload-footer {
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.avatar-upload-wrap .avatar-upload-footer button {
  margin-left: 10px;
}
</style>
